import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/Layout';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Certificates from './pages/Certificates';
import SinglePost from './pages/SinglePost';
import BlogPage from './pages/BlogPage';
import { Analytics } from '@vercel/analytics/react';

function App() {
  const location = useLocation();
  useEffect(() => {
    Aos.init({
      once: true,
      duration: 1000,
      easing: 'ease-in-out',
      throttleDelay: 99, // Throttles scroll events for better performance
      offset: 100, // Trigger animations slightly earlier/later
    });
    const handleLoad = () => {
      Aos.refresh();
    };
    window.addEventListener('load', handleLoad);
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);
  useEffect(() => {
    // Refresh AOS when the route changes so newly mounted elements animate correctly
    Aos.refresh();
  }, [location.pathname]);
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<SinglePost />} />
        </Route>
      </Routes>
      <Analytics />
    </>
  );
}

export default App;
